import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ValidationProblem, Order } from 'dist/reg-hub-common/types/reg-hub-common';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';
import { SteppedComponent } from 'projects/reg-hub-client/src/interfaces/stepped-component';
import { Party, Utilities } from 'reg-hub-common'
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-land-title-search-criteria-review',
  templateUrl: './land-title-search-criteria-review.component.html',
  styleUrl: './land-title-search-criteria-review.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LandTitleSearchCriteriaReviewComponent extends SteppedComponent {
  protected party!: Observable<Party[]>;
  protected address?: string;

  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return StepValidationState.DefaultState;
  }

  public override ngOnInit(): void {
    super.ngOnInit();

    if (this.order.landTitleSearchCriteria?.party) {
      this.party = of([this.order.landTitleSearchCriteria.party]);
    }

    if (this.order.landTitleSearchCriteria?.address) {
      this.address = Utilities.formatAddress(this.order.landTitleSearchCriteria.address);
    }
  }
}
